import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  useMediaQuery,
  useTheme
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DialogCustom = ({ open, onClose, title, children, maxWidth }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // 👈 Detecta móviles

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      fullScreen={isMobile} // 👈 Solo fullscreen en móviles
      sx={{
        zIndex: 1300,
      }}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 2, // sin bordes en móviles, redondeado en escritorio
          minHeight: isMobile ? '100vh' : '60vh',
          maxHeight: isMobile ? '100vh' : '90vh',
          zIndex: 1301,
        },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          position: 'sticky',
          top: 0,
          zIndex: 1,
        }}
      >
        <Typography component="span" sx={{ fontSize: '1.25rem', fontWeight: 500 }}>{title}</Typography>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent 
        dividers
        sx={{
          p: 0,
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
          },
        }}
      >
        <Box>{children}</Box>
      </DialogContent>
    </Dialog>
  );
};

DialogCustom.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
};

DialogCustom.defaultProps = {
  title: "",
  children: null,
  maxWidth: "sm",
};

export default DialogCustom;
